export default [
    {
        title: "Have an online shop",
        header: "Taking it to the next level",
        text: "So, you already have your Shopify store. No worries! We offer different services to fit your needs. Need new pages, a full redesign, or help with ongoing maintenance? We’ve got you covered. There’s a variety of options available, so let’s get started."
    },
    {
        title: "Have an online business",
        header: "Making your business more accessible",
        text: "If your store is offline, you can still reach hundreds of customers through creating online stores. Show them your brand while maintaining your in-person business. Your store becomes easier to reach and represent from anywhere in the world! "
    },
    {
        title: "Want to migrate to shopify",
        header: "Change can be tough Let Shopify Systems help you out",
        text: "When deciding to transition from an eCommerce to a Shopify platform, don’t let your data and progress get lost in translation. Our services make it easy to keep all of your information and eliminates the risk of losing it in the switching process. We help you make the transition from any eCommerce platform to Shopify efficient and easy"
    },
    {
        title: "Want to start a new store",
        header: "For the creatives",
        text: "So, you want to start from scratch? This is a bold move, but it doesn’t have to be intimidating. Being able to build a website from the ground up means designing it exactly the way you want. Why settle for something basic? With Shopify Systems, we can construct the perfect design for you."
    },
]